// Capitalize
export const capitalizeFirstLetter = (string) =>
	string.charAt(0).toUpperCase() + string.slice(1);

export const capitalizeWords = (string) => {
	return string.replace(/(?:^|\s)\S/g, function (a) {
		return a.toUpperCase();
	});
};
